module.exports = __webpack_public_path__ + "img/mistakesText12.108924f7.png";